import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'guion'
})
export class GuionPipe implements PipeTransform {

  transform(value: any, type?:string): any {

    if(type == 'number'){
      let data1:any = (value === null || value === undefined )?0:value;
      // return (parseFloat(data1)).toFixed(2);
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }else if (type == 'mixin'){

    }else{
      let data2:any = (value === '' || value === null || value === undefined )?'-':value;
      return data2;
    }
  }

}
